// Same-origin call to portalv2-agent, proxied by nginx under /agent-api/ ->
// http://127.0.0.1:8787/ (see /etc/nginx/sites-available/portalv2). Hardcoded
// relative path, not a REACT_APP_* env var: this is same-origin by
// construction and identical across environments that follow this nginx
// pattern, unlike REACT_APP_API_URL/REACT_APP_FETCH_API_URL which are
// genuinely cross-origin and vary per environment.
const CHAT_API_PATH = "/agent-api/api/chat";

export interface ChatIdentity {
  name?: string;
  email?: string;
}

export interface ChatResponse {
  reply: string;
  pendingConfirmation: boolean;
  actuallyExecuted?: boolean;
  error?: string;
}

export const sendChatMessage = async (
  threadId: string,
  identity: ChatIdentity,
  message: string,
): Promise<ChatResponse> => {
  const result = await fetch(CHAT_API_PATH, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ threadId, identity, message }),
  });
  const data = await result.json();
  if (!result.ok) {
    return { reply: data.error ?? "Something went wrong.", pendingConfirmation: false, error: data.error };
  }
  return data;
};
